import cashdesk from './src/cashdesk.vue'

cashdesk.install = function (Vue) {
    Vue.component(cashdesk.name, cashdesk)
}

export default cashdesk



// WEBPACK FOOTER //
// ./node_modules/@kkmh/pays/src/components/cashdesk/index.js